import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { TrackingEvents, sendLoggingEvents } from '../../events';
import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { useSendProviderParticipantStateCallback } from '../../provider/messages/useSendProviderParticipantStateCallback';
import { useTrackEvent } from '../../segment/segment';
import { EventTypeEnum } from '../../segment/types';
import { sessionInfoAtom } from '../../state';
import { isWhiteboardModeAtom } from '../messages/state';

export const useWhiteboardCallbacks = () => {
  const setIsWhiteboardMode = useSetAtom(isWhiteboardModeAtom);
  const sendParticipantState = useSendProviderParticipantStateCallback();
  const { userClicked } = useTrackEvent();
  const getSessionInfo = useAtomCallbackMemoized((get) => get(sessionInfoAtom), []);

  const startWhiteboard = useCallback(async () => {
    setIsWhiteboardMode({
      value: true,
      lastUpdated: Date.now(),
    });
    sendLoggingEvents(TrackingEvents.PROVIDER_WHITEBOARD_SHARE);
    userClicked(EventTypeEnum.PROVIDER_START_WHITEBOARD, {
      appointmentShortId: getSessionInfo()?.appointment?.shortId ?? '',
    });
    //this sends updated state to the visitor, indicating that they should open the whiteboard
    await sendParticipantState();
  }, [setIsWhiteboardMode, sendParticipantState, userClicked, getSessionInfo]);

  const stopWhiteboard = useCallback(async () => {
    setIsWhiteboardMode({
      value: false,
      lastUpdated: Date.now(),
    });
    sendLoggingEvents(TrackingEvents.PROVIDER_WHITEBOARD_STOP_SHARE);
    userClicked(EventTypeEnum.PROVIDER_END_WHITEBOARD, {
      appointmentShortId: getSessionInfo()?.appointment?.shortId ?? '',
    });
    await sendParticipantState();
  }, [setIsWhiteboardMode, sendParticipantState, userClicked, getSessionInfo]);

  return { startWhiteboard, stopWhiteboard };
};
